import { useMemo } from 'react';

import { useAppSelector } from '@src/core/hooks';
import type { Transactable } from '@src/domains/transactables';
import { currentOrderSelector } from '@src/features/orders';
import { directLinkStateSelector } from '@src/stores/directLink';
import { currentSaleSelector } from '@src/stores/sale';
import { currentSaleChangeSelector } from '@src/stores/saleChange';

/** The four shapes a checkout can be charging, as the store holds them. */
export const useTransactable = (): Transactable => {
  const order = useAppSelector(currentOrderSelector);
  const sale = useAppSelector(currentSaleSelector);
  const saleChange = useAppSelector(currentSaleChangeSelector);
  const { directLink } = useAppSelector(directLinkStateSelector);

  return useMemo(() => ({ order, sale, saleChange, directLink }), [order, sale, saleChange, directLink]);
};

export default useTransactable;
